import { FaqForm } from './FaqForm';
import { FaqParentProps, PageStatus } from './types';
import type { FaqItem } from './types';

type Props = FaqParentProps & {
    data: FaqItem;
    changePage: (status: PageStatus, data?: FaqItem | null) => void;
    onSaved: () => void;
};

export const EditFaq = ({
    data,
    changePage,
    onSaved,
    ...parentProps
}: Props) => (
    <FaqForm
        initialData={data}
        {...parentProps}
        onCancel={() => changePage(PageStatus.MAIN, null)}
        onSaved={onSaved}
    />
);
